




































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import Context from "@/mixins/context";
import { IClient } from "@/models/clients";
import { DataModules } from "@/store/modules/data";

@Component({
  components: {
    "invoices-provider": () =>
      import("@/components/app/global/invoices/invoicesProvider.vue"),
    "relative-invoice-status": () =>
      import("@/components/app/global/invoices/relativeInvoiceStatus.vue"),
    "order-items-summary": () =>
      import("@/components/app/global/orders/orderItemsSummary.vue")
  }
})
export default class RecentInvoicesList extends Mixins(Context) {
  // Props
  @Prop({ default: null })
  public clientId!: IClient["id"];

  @Prop({ default: 5 })
  public limit!: number;

  public get canList() {
    return this.$userCan(
      ...this.$store.getters[`data/${DataModules.INVOICES}/listFunctionalities`]
    );
  }
}
